{
  "name": "regattas.web",
  "version": "1.1.112",
  "author": "Vilius Roškus <info@regattas.eu>",
  "license": "MIT",
  "engines": {
    "node": ">=20.0.0"
  },
  "main": "dist/index.html",
  "scripts": {
    "dev": "yarn dev:pre && yarn dev:run",
    "dev:pre": "yarn conf",
    "dev:run": "SERVE=8080 SOURCE_FILE_PATH=src/index.tsx node scripts/build.js",
    "prebuild": "rm -Rf dist",
    "build": "BUILD_PATH=dist SOURCEMAP='' SOURCE_FILE_PATH=src/index.tsx node scripts/build.js",
    "conf": "config-web src/config.ts dist/config.js",
    "start": "serve -s dist",
    "test": "yarn test:eslint && yarn test:type && yarn test:dead && yarn test:e2e",
    "test:eslint": "eslint src test scripts --fix",
    "test:type": "tsc",
    "test:dead": "npm run test:deadcode && npm run test:deadfile",
    "test:deadcode": "ts-prune -i dist | grep -v '(used in module)' || echo 'No unused code!'",
    "test:deadfile": "deadfile --ci src/index.tsx --dir src --exclude theme test_e2e mocks.tsx .ttf .woff .png",
    "test:e2e": "start-server-and-test test:e2e:pre http://localhost:7001 test:e2e:run && yarn test:e2e:post",
    "test:e2e:pre": "yarn test:e2e:pre:clean && yarn test:e2e:pre:build && yarn test:e2e:pre:conf && yarn test:e2e:pre:serve",
    "test:e2e:pre:clean": "rm -rf .nyc_output && rm -rf coverage && rm -rf test_build",
    "test:e2e:pre:build": "BUILD_PATH=test_build COVERAGE=true SOURCE_FILE_PATH=src/index.tsx node scripts/build.js",
    "test:e2e:pre:conf": "DEPLOYMENT_ENV=TEST config-web src/config.ts test_build/config.js",
    "test:e2e:pre:serve": "PORT=7001 serve -s test_build",
    "test:e2e:run": "CYPRESS_baseUrl=http://localhost:7001 cypress run",
    "test:e2e:post": "nyc report && compare-coverage-thresholds && jest-coverage-thresholds-bumper",
    "test:e2e:console": "CYPRESS_baseUrl=http://localhost:7001 cypress open",
    "test:e2e:report": "open coverage/lcov-report/index.html",
    "upload:sourcemaps": "upload-sourcemaps",
    "analyze": "yarn build && source-map-explorer dist/*.js --no-border-checks"
  },
  "dependencies": {
    "@chiragrupani/fullscreen-react": "1.2.5",
    "@fortawesome/fontawesome-free": "6.6.0",
    "@react-google-maps/api": "2.19.3",
    "@tailwindcss/aspect-ratio": "0.4.2",
    "@vroskus/library-api": "1.0.17",
    "@vroskus/library-cookies": "1.0.21",
    "@vroskus/library-error": "1.0.28",
    "@vroskus/library-helpers": "1.0.20",
    "@vroskus/library-mixpanel": "1.0.20",
    "@vroskus/library-navigation": "1.0.13",
    "@vroskus/library-sentry": "1.0.24",
    "@vroskus/library-socket": "1.0.19",
    "@vroskus/library-validator": "1.0.25",
    "common.data": "^1.0.28",
    "common.enums": "^1.0.38",
    "common.helpers": "^1.0.50",
    "common.language": "^1.0.20",
    "common.types": "^1.0.15",
    "country-flag-icons": "1.5.13",
    "fast-text-encoding": "1.0.6",
    "formsy-react": "2.3.2",
    "line-awesome": "1.3.0",
    "lodash": "4.17.21",
    "moment": "2.29.4",
    "react": "18.3.1",
    "react-app-polyfill": "3.0.0",
    "react-autosuggest": "10.1.0",
    "react-copy-to-clipboard": "5.1.0",
    "react-dom": "18.3.1",
    "react-facebook-login": "4.1.1",
    "react-google-login": "5.2.2",
    "react-helmet": "6.1.0",
    "react-hooks-svgdrawing": "2.1.2",
    "react-i18next": "15.0.1",
    "react-icons": "5.3.0",
    "react-lms-vis-timeline": "3.0.1",
    "react-modal-image": "2.6.0",
    "react-redux": "9.1.2",
    "react-router-dom": "6.26.1",
    "react-share": "5.1.0",
    "react-slider": "2.0.6",
    "redux": "5.0.1",
    "redux-logger": "3.0.6",
    "redux-promise-middleware": "6.2.0",
    "redux-thunk": "3.1.0",
    "svg-classlist-polyfill": "1.1.0",
    "xss": "1.0.15",
    "zod": "3.23.8"
  },
  "devDependencies": {
    "@cypress/code-coverage": "3.12.45",
    "@types/react": "18.3.3",
    "@types/react-router-dom": "5.3.3",
    "@vroskus/build-web": "1.0.22",
    "@vroskus/compare-coverage-thresholds": "1.0.6",
    "@vroskus/config-web": "1.0.9",
    "@vroskus/eslint-config": "1.0.13",
    "@vroskus/upload-sourcemaps": "1.0.9",
    "autoprefixer": "10.4.20",
    "backstopjs": "6.3.23",
    "cypress": "13.9.0",
    "deadfile": "2.1.1",
    "esbuild-style-plugin": "1.6.3",
    "eslint-plugin-cypress": "3.5.0",
    "jest": "29.7.0",
    "jest-coverage-thresholds-bumper": "1.1.0",
    "npm-check": "6.0.1",
    "nyc": "17.0.0",
    "nyc-config-tsx": "0.1.0",
    "postcss": "8.4.41",
    "serve": "14.2.3",
    "source-map-explorer": "2.5.3",
    "start-server-and-test": "2.0.5",
    "tailwindcss": "3.4.10",
    "ts-prune": "0.10.3",
    "typescript": "5.5.4"
  },
  "nyc": {
    "all": true,
    "root": "src",
    "reporter": [
      "json-summary",
      "lcov",
      "text"
    ],
    "include": [
      "src"
    ],
    "exclude": [],
    "extends": "nyc-config-tsx"
  },
  "jest": {
    "reporters": [
      "default"
    ],
    "collectCoverage": true,
    "coverageThreshold": {
      "global": {
        "branches": 20.62,
        "functions": 43.93,
        "lines": 45.19,
        "statements": 45.36
      }
    }
  },
  "uploadSourcemapsConfig": {
    "org": "regattas",
    "project": "regattas-web",
    "authToken": "90abb973f6564ad6aa6ce40cc112055d8531ae56bd564811b7f4ba7fae5c7d35",
    "filesPath": "dist"
  },
  "browserslist": [
    ">0.2%",
    "not dead",
    "not ie <= 11",
    "not op_mini all"
  ]
}
